namespace GeniuzPOS.ReportMasterData {
    export class Report_1404Columns {
        static columnsKey = 'ReportMasterData.Report_1404';
    }
}
